const status = {
  WORKING: {code: 102, text: '対応中'},
  NEW_APPLICATION: {code: 1, text: '新規申請'},
  CONFIRMING_APPLICATION: {code: 2, text: '申請内容確認中'},
  MODIFICATION_REQUEST: {code: 3, text: '申請内容修正要求'},
  REAPPLICATION: {code: 4, text: '再申請'},
  WAITING_BANK_TRANSFER: {code: 5, text: '発行手数料振込待ち'},
  WAITING_CONFIRM_TRANSFER_STATEMENT: {code: 6, text: '振込明細書確認待ち'},
  CONFIRMING_TRANSFER_STATEMENT: {code: 7, text: '振込明細書確認中'},
  TRANSFER_STATEMENT_NG: {code: 8, text: '振込明細書NG'},
  ISSUING: {code: 9, text: '発行中'},
  ISSUANCE_COMPLETED: {code: 10, text: '発行完了'},
  DOWNLOAD_COMPLETED: {code: 11, text: 'ダウンロード完了'},
  REISSUANCE_REQUEST: {code: 12, text: '再発行依頼'},
  REJECTED: {code: 13, text: '却下'},
  CANCELED: {code: 14, text: 'キャンセル'},
}
const allowed_upload_transfer_statement_code = [
  status.WAITING_BANK_TRANSFER.code,
  status.TRANSFER_STATEMENT_NG.code
]
const allowed_delete_transfer_statement_code = [
  status.WAITING_BANK_TRANSFER.code,
  status.TRANSFER_STATEMENT_NG.code
]
const max_building_list_items = 1000
const operation = {
  CANCELED: 'Canceled',     // 発行依頼キャンセル
}
const receipt_status = {
  RECEIPT_STATUS_UNISSUED: 0,                   // 未発行
  RECEIPT_STATUS_ISSUED: 1,                     // 発行済
  RECEIPT_STATUS_REISSUE_REQUEST: 2,            // 再発行依頼
  RECEIPT_STATUS_REISSUE_PERMIT: 3,             // 再発行許可
  RECEIPT_STATUS_REISSUE_NG: 4,                 // 再発行NG
  RECEIPT_STATUS_REISSUE_DONE: 5,               // 再発行済
}

export default {
  status,
  allowed_upload_transfer_statement_code,
  allowed_delete_transfer_statement_code,
  max_building_list_items,
  operation,
  receipt_status,
}
